import locationMetadata from './location-data';
import spaceStationMetadata from './space-station-data';

export const locationData = locationMetadata;

export const spaceStationData = spaceStationMetadata;
